module.exports = __webpack_public_path__ + "img/52114131_L.d1922a7c.png";